<style scoped src="@/assets/css/all.css"></style>
<style scoped src="@/assets/css/style.css"></style>
<style scoped src="@/assets/css/components/multiselection-picker.css"></style>

<style scoped>
input:-moz-placeholder,
textarea:-moz-placeholder {
  color: #495057 !important;
}
input:-ms-input-placeholder,
textarea:-ms-input-placeholder {
  color: #495057 !important;
}
input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
  color: #495057 !important;
}
</style>

<template>
  <div>
    <div class="input-group">
      <div class="input-group-prepend">
        <button class="input-group-text bg-orange text-white">
          <i class="fas fa-search pl-2 pr-2" />
        </button>
      </div>
      <input
        v-model="filterText"
        class="form-control general-textarea2"
        :placeholder="`Escriba aquí para buscar un(a) ${itemTypeName}`"
        type="text"
      />
    </div>
    <div class="panel-body bg-white">
      <div class="t1-pei">
        <div class="t2-pei">
          <div class="row">
            <div
              v-for="(column, index) in columns"
              :key="index"
              :class="`col col-${12 / columnCount}`"
            >
              <div
                v-for="(item, name) in column"
                :key="name"
                class="multiselect-item d-flex bd-highlight"
                @click.prevent="onItemSelected(item)"
              >
                <span class="mr-auto bd-highlight">
                  {{ item[textPropName] }}
                </span>
                <i
                  v-if="allowItemListEditing"
                  class="far fa-edit icon-green bd-highlight"
                  @click.prevent.stop="onItemEdit(item)"
                />
                <i
                  v-if="allowItemListEditing"
                  class="far fa-times-circle icon-red mr-4 bd-highlight"
                  @click.prevent.stop="onItemDeleted(item)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <p v-if="allowItemListEditing" class="bold mb-1 mt-3">
      {{ itemEditionTitle }}
    </p>
    <div v-if="allowItemListEditing">
      <div class="input-group">
        <input
          v-model="newItemText"
          class="form-control general-textarea2"
          :maxlength="maxlength"
          :placeholder="itemEditionPlaceholder"
          type="text"
          @keyup="onItemChangeKeyUp"
        />
        <div class="input-group-append">
          <button
            class="input-group-text btn bg-white border-green"
            type="button"
            @click="onItemChange"
          >
            <i v-if="!isEditing" class="fas fa-plus pl-2 pr-2" />
            <i v-else class="fas fa-save pl-2 pr-2" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MultiSelectionPicker',
  meta: {
    description: 'Componente común para selección múltiple.',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  props: {
    //ECG:Array de pares {id, text}. Hace falta para que esto sea util, pero no la hice requerida para que el implementador decida cuando inicializar.
    allItems: {
      type: Array,
      required: false,
      default: () => [],
      meta: {
        description: 'Propiedad que requiere array de pares',
        example: '{id, text}',
      },
    },
    selectedItems: {
      type: Array,
      default: () => [],
      meta: {
        description: 'Permite la selección de los artículos',
        example: '[4, 8, 15, 16, 23, 42]',
      },
    },
    //ECG:Cuantas columnas deseas renderizar para la seleccion de elementos
    columnCount: {
      type: Number,
      default: 1,
      meta: {
        description:
          'Establece las columnas a renderizar para la selección de elementos',
        example: '2',
      },
    },
    //ECG:Permitir seleccionar mas de una opcion. Si es falso, el seleccionar una segunda opcion elimina solo la seleccionada de las disponibles.
    allowMultipleSelection: {
      type: Boolean,
      default: true,
      meta: {
        description: 'Permite seleccionar más de una opción',
        example: 'true',
      },
    },
    //ECG:Permitir editar lista de opciones. Muestra elementos para añadir nuevo, editar y eliminar.
    allowItemListEditing: {
      type: Boolean,
      default: false,
      meta: {
        description: 'Permite editar lista de opciones',
        example: 'true',
      },
    },
    //ECG:Si se indica que se permite editar la lista de opciones, se muestra un label indicando que se esta añadiendo o modificando un(a) "XXX" al listado
    itemTypeName: {
      type: String,
      required: () => this.allowItemListEditing === true,
      default: '',
      meta: {
        description:
          'Establece un label indicando el nombre del que se esta añadiendo',
        example: 'Texto requerido',
      },
    },
    //ECG:Indica si la accion de editar remueve el elemento de la lista de todas. Valor falso solo actualiza el valor existente en la lista
    modifyRemovesItem: {
      type: Boolean,
      default: false,
      meta: {
        description: 'Indica si la accion de editar remueve el elemento',
        example: 'true',
      },
    },
    //ECG:nombre de prop en objetos de lista allItems con valor id
    idPropName: {
      type: String,
      default: 'id',
      meta: {
        description: 'Nombre de prop en objetos de lista allItems con valor id',
        example: 'Id',
      },
    },
    //ECG:nombre de prop en objetos de lista allItems con valor textual a mostrar
    textPropName: {
      type: String,
      default: 'name',
      meta: {
        description:
          'Nombre de prop en objetos de lista allItems con valor textual a mostrar',
        example: 'Texto requerido',
      },
    },
    // Cantidad máxima de caracteres permitida para un nuevo item
    maxlength: {
      type: String,
      default: '',
      meta: {
        description:
          'Cantidad máxima de caracteres permitida para un nuevo item',
        example: 'Texto requerido',
      },
    },
    removeToSelect: {
      type: Boolean,
      default: false,
      meta: {
        description: 'Opción para remover antes de seleccionar',
        example: false,
      },
    },
    customLabel: {
      type: String,
      default: '',
      meta: {
        description: 'Label personalizado para input de texto',
        example: 'Añadir nuevo item',
      },
    },
    customPlaceholder: {
      type: String,
      default: '',
      meta: {
        description: 'Placeholder personalizado para input de texto',
        example: 'Escriba',
      },
    },
  },
  data() {
    return {
      filterText: '',
      newItemText: '',
      isEditing: false,
      editedItemId: '',
    };
  },

  computed: {
    availableItems() {
      return this.allItems
        ? this.allItems.filter(
            (i) =>
              !this.selectedItems.find(
                (e) => e[this.idPropName] === i[this.idPropName]
              ) &&
              (!this.filterText ||
                i[this.textPropName]
                  .toLowerCase()
                  .trim()
                  .includes(this.filterText.toLowerCase().trim()))
          )
        : [];
    },
    columns() {
      let columns = [];
      let mid = Math.ceil(this.availableItems.length / this.columnCount);
      for (let col = 0; col < this.columnCount; col++) {
        columns.push(this.availableItems.slice(col * mid, col * mid + mid));
      }
      return columns;
    },
    itemEditionTitle() {
      let titleText = '';
      if (this.customLabel) return this.customLabel;
      if (this.isEditing) {
        titleText = `Editar ${this.itemTypeName} de su listado`;
      } else {
        titleText = `Añadir nuevo(a) ${this.itemTypeName} a su listado`;
      }
      return titleText;
    },
    itemEditionPlaceholder() {
      let placeholderText = '';
      if (this.customPlaceholder) return this.customPlaceholder;
      if (!this.isEditing) {
        placeholderText = `Escriba nuevo(a) ${this.itemTypeName}`;
      }
      return placeholderText;
    },
  },
  methods: {
    onItemSelected(item) {
      //ECG:Añado a coleccion de seleciconadas immediatamente para dar feedback visual al momento, pero se deberia reemplazar con la lista
      //proviniente de la DB para mostrar el efecto real en los datos
      if (!this.allowMultipleSelection) {
        if (this.removeToSelect && this.selectedItems.length) {
          this.$emit('remove-single-item-first');
          return;
        } else {
          this.selectedItems.splice(0, this.selectedItems.length);
        }
      }
      this.selectedItems.push(item);
      this.$emit('selected-item', { ...item }); //ECG: ...item para no pasar el observable
    },
    onItemDeleted(item) {
      //ECG:No me adelanto a modificar allItems porque puede haber confirmacion de la eliminacion
      this.$emit('delete-item', { ...item });
    },
    onItemEdit(item) {
      this.isEditing = true;
      this.newItemText = item[this.textPropName];
      this.editedItemId = item[this.idPropName];
    },
    onItemChangeKeyUp(event) {
      if (event.keyCode === 13) {
        this.onItemChange();
      }
    },
    onItemChange() {
      if (this.isEditing) {
        this.modifyItem();
      } else {
        this.addItem();
      }
    },
    addItem() {
      if (this.newItemText) {
        this.$emit('add-item', this.newItemText);
      }
      this.newItemText = '';
    },
    modifyItem() {
      if (this.newItemText) {
        let editedItem = {
          [this.idPropName]: this.editedItemId,
          [this.textPropName]: this.newItemText,
        };
        let editedItemIndex = this.allItems.findIndex(
          (e) => e[this.idPropName] === this.editedItemId
        );
        if (this.modifyRemovesItem) {
          //ECG:Envio en indice tambien para cuando crees el elemento nuevo lo puedas insertar en el mismo indice y simular el editado
          //cuando realmente fue un delete-insert ;)
          this.allItems.splice(editedItemIndex, 1);
        } else {
          this.allItems.find(
            (e) => e[this.idPropName] === editedItem[this.idPropName]
          )[this.textPropName] = editedItem[this.textPropName];
        }
        this.$emit('edit-item', editedItem, editedItemIndex);
      }
      this.newItemText = '';
      this.editedItemId = '';
      this.isEditing = false;
    },
  },
};
</script>
<style>
.border-green {
  border: 1px solid #28a745;
}
</style>
